import { render, staticRenderFns } from "./UserGuideShopifyIntegration.vue?vue&type=template&id=c28868a8&"
import script from "./UserGuideShopifyIntegration.vue?vue&type=script&lang=ts&"
export * from "./UserGuideShopifyIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports